import { BlogPagePreview } from './blogQueries';
import { usePageDataset } from '../../../templates/PageDatasetsContext';

export const useSupport = (required = true): BlogPagePreview[] => {
    return usePageDataset('pageSupport', required)?.nodes ?? [];
};
